import { render, staticRenderFns } from "./CurrentlyReadingCard.vue?vue&type=template&id=903b1868&"
import script from "./CurrentlyReadingCard.vue?vue&type=script&lang=js&"
export * from "./CurrentlyReadingCard.vue?vue&type=script&lang=js&"
import style0 from "./CurrentlyReadingCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports